import { ImageService, ContentService, ObserverService } from '@DavisDigital/davisdigitalfrontend.module';
import { ContentModuleTypes, EVENTS } from '@DavisDigital/interfaces';

class AddVideoModalController {
	
	public contentModule : any;
	public images : [];
	public lesson : any;
	public lessonId : string;
	
	public editMode = false; 
	public isLoading = false;
	
	public portfolioPageId;
	public position;
	
	public videoEmbed:string;
	public videoCaption:string;

	private previouslyFocusedElement: HTMLElement | null = null;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	
	// @ngInject
	constructor(
		public imageService		: ImageService,
		public contentService   : ContentService, 
		public observerService	: ObserverService,
		public ModalService,
		public $element,
		public $timeout			: ng.ITimeoutService
	){}
	
	public $onInit = () => {

		// Store the element that had focus before the modal opened
		this.previouslyFocusedElement = document.activeElement as HTMLElement;
		
		if(this.contentModule != null){
			this.videoCaption = this.contentModule.title
			this.videoEmbed = this.contentModule.bodyHTML;
		} else {
			this.contentModule = this.contentService.newContentModule( ContentModuleTypes.VIDEO, this.position);
		}

		// Set initial focus to the close button after render
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		const focusableElements = modalEl.querySelectorAll(this.focusableSelector);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0] as HTMLElement;
		const lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement;

		if (event.shiftKey) {
			if (document.activeElement === firstFocusable) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else {
			if (document.activeElement === lastFocusable) {
				event.preventDefault();
				firstFocusable.focus();
			}
		}
	}
	
	public save = () =>{
		
		let notifyId = this.lessonId?.length ? this.lessonId : this.portfolioPageId;
		
		this.contentModule.title = this.videoCaption;
		this.contentModule.bodyHTML = this.videoEmbed;
		
		var eventName = EVENTS.UPDATE_CONTENT ;
		
		if( !this.contentModule.contentModuleID || 
			 this.contentModule.contentModuleID.length !== 32
		){
			eventName = EVENTS.ADD_CONTENT;
		}
		
		this.observerService.notifyById( eventName, notifyId, this.contentModule);
		
		this.close();
	}
	
	public close = () =>{
		this.ModalService.closeModals();

		// Restore focus to the previously focused element
		if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
			this.previouslyFocusedElement.focus();
		}
	}

}

class AddVideoModal {
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		type:'=',
		contentModule:'=?',
		lesson:'=?',
		lessonId:'=?',
		portfolioPageId:'=?',
		position:'='
	};

	public controller = AddVideoModalController;
	public controllerAs = 'addVideoModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/add-video-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { AddVideoModal };
